import React from 'react';
import PropTypes from 'prop-types';

import { mergeClasses } from '@utils';

/**
 * Label component for displaying Labels.
 *
 * @component Label
 * @param {Object} props - The properties object for the Label component.
 * @param {string} props.children - The text content of the Label.
 * @param {string} [props.className] - Additional CSS class(es) to be applied to the Label.
 * @param {Object} [props.restProps] - Additional properties to be passed to the `<div>` element.
 * @returns {React.Element} A `Label` component.
 *
 * @example
 * <Label>My Label</Label>
 */
export default function Label({ children, className, ...restProps }) {
  return (
    <span
      className={mergeClasses(
        'w-fit rounded bg-green px-2 py-1 text-xs font-semibold text-black',
        className
      )}
      {...restProps}
    >
      {children}
    </span>
  );
}

Label.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string
};

Label.defaultProps = {
  className: ''
};
